import React from 'react';

import { Stack, Typography } from '@mui/material';

// eslint-disable-next-line modernloop/validate-component-definition.cjs
const CreateDetailsRow = ({
  label,
  component,
}: {
  label: string | React.ReactNode;
  component: React.ReactNode | undefined;
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
      {!React.isValidElement(label) && (
        <Typography variant="body1" sx={{ flexShrink: 0 }}>
          {label}
        </Typography>
      )}
      {React.isValidElement(label) && label}
      {component}
    </Stack>
  );
};

export default CreateDetailsRow;
